/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap-button-loader';
import FileReaderInput from 'react-file-reader-input';
import csvToJson from 'csvtojson';
import * as Sentry from '@sentry/browser';
import './ImportCSV.sass';
import _ from 'underscore';

class ImportCSV extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileContents: null,
      error: null,
      waiting: false,
      rawFile: null,
    };
  }

  processFileSafe = (e, results) => {
    try {
      if (this.props.useRawFile) {
        results.forEach((result) => {
          const [, file] = result;
          // Validate empty file
          if (file.size < 10) {
            this.props.onShowNotification('The selected file is empty');
            this.setState({
              fileContents: null, // Reset to allow another upload
              rawFile: null,
              waiting: false, // Stop loading if it was active
            });
            return;
          }
          this.setState({
            rawFile: file,
            fileContents: [{ name: file.name }],
          });
        });
      } else {
        this.processFile(e, results);
      }
    } catch (err) {
      this.props.onShowNotification(
        'Oops! This is an invalid file, please review your spreadsheet for errors and try again.',
      );
      this.setState({
        fileContents: null,
        rawFile: null,
        waiting: false,
      });
      Sentry.captureException(err);
    }
  };

  processFile = (e, results) => {
    results.forEach((result) => {
      const [event, file] = result;
      // Decide whether you're importing csv or xlsx format and handle it
      if (file.type.indexOf('csv') >= 0) {
        csvToJson({
          ignoreEmpty: true,
          headers: [
            'question',
            'questionImageLink',
            'correctanswer',
            'correctanswerImageLink',
            'incorrectanswer_0',
            'incorrectanswerImageLink_0',
            'incorrectanswer_1',
            'incorrectanswerImageLink_1',
            'incorrectanswer_2',
            'incorrectanswerImageLink_2',
            'notes',
            'softwarepage',
            'flashmode',
            'flashmodeonly',
            'documentpage',
          ],
          colParser: {
            question: 'string',
            questionImageLink: 'string',
            correctanswer: 'string',
            correctanswerImageLink: 'string',
            incorrectanswer_0: 'string',
            incorrectanswerImageLink_0: 'string',
            incorrectanswer_1: 'string',
            incorrectanswerImageLink_1: 'string',
            incorrectanswer_2: 'string',
            incorrectanswerImageLink_2: 'string',
            notes: 'string',
            softwarepage: 'number',
            flashmode: 'number',
            flashmodeonly: 'number',
            documentpage: 'string',
          },
        })
          .fromString(decodeURIComponent(escape(event.target.result)))
          .then((jsonArrObj) => {
            this.processResult(jsonArrObj);
          });
      } else {
        let wb = window.XLSX.read(event.target.result, {
          type: 'binary',
          raw: false,
        });
        let sheetNameList = wb.SheetNames;
        let sheetJSON = window.XLSX.utils.sheet_to_json(
          wb.Sheets[sheetNameList[0]],
          {
            raw: false,
          },
        );
        const paredSheetJSON = sheetJSON.map((row) => {
          row.softwarepage = parseInt(row.softwarepage);
          row.flashmode = parseInt(row.flashmode);
          row.flashmodeonly = parseInt(row.flashmodeonly);

          return row;
        });

        this.processResult(paredSheetJSON);
      }
    });
  };

  processResult = (JSONResult) => {
    let processedFile = JSONResult.map((question) => {
      let key,
        keys = Object.keys(question);
      let keysLength = keys.length;
      let newObj = {};
      while (keysLength--) {
        key = keys[keysLength];
        newObj[key.toLowerCase().trim()] = question[key];
      }
      return newObj;
    });
    this.setState({ fileContents: processedFile });
  };

  render() {
    const {
      onConfirm,
      onCancel,
      title = 'Import Questions',
      yesButtonText = 'Import questions',
      noButtonText = 'Cancel',
      templateLink = 'https://promotionwingman-prod.nyc3.cdn.digitaloceanspaces.com/templates/admin_import_question_template.csv',
      fileType = 'question',
      greenButton,
    } = this.props;

    return (
      <div className="import-component">
        <div className="card-block">
          <div className="title">
            {title}
            <i
              style={{ cursor: 'pointer' }}
              className="fa fa-times fa-xs"
              onClick={() => this.props.onCancel()}
            />
          </div>
          <p>
            <a href={templateLink} target="_blank">
              Example Template
            </a>
          </p>
          <form
            className="widget-form import-csv-form"
            onSubmit={(ev) => {
              ev.preventDefault();
              this.setState({ waiting: true });
              if (this.props.useRawFile) {
                onConfirm(this.state.rawFile);
              } else {
                onConfirm(this.state.fileContents);
              }
            }}
          >
            <hr className="titleHR" />
            <FileReaderInput
              className="file-input"
              as="binary"
              id="my-file-input"
              onChange={this.processFileSafe}
            >
              {this.state.fileContents ? (
                this.state.fileContents.length && (
                  <div className="question-wrapper">
                    {this.props.useRawFile ? (
                      <div>
                        <p>File selected:</p>
                        <p>
                          <strong>{this.state.rawFile?.name}</strong>
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p>You are about to import the following questions:</p>
                        <div className="question-container">
                          <div>
                            {this.state.fileContents.map((line, index) => {
                              return (
                                <div key={index} className="question-line">{`${
                                  index + 1
                                }. ${line.question}`}</div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              ) : (
                <div className="upload-text-info">
                  <p>You may upload a {fileType} file in .csv format only.</p>
                  <p>
                    <b>
                      Please do not remove or change the column order before
                      importing the file.
                    </b>
                  </p>

                  <button type="button">Choose file to import</button>
                </div>
              )}
            </FileReaderInput>

            {this.state.error ? (
              <div className="errors">{this.state.error}</div>
            ) : null}
            {this.state.fileContents && (
              <div className="bottom-buttons">
                <Button className="btn btn-secondary" onClick={onCancel}>
                  {noButtonText}
                </Button>
                <Button
                  className={greenButton ? 'btn btn-success' : 'btn btn-danger'}
                  type="submit"
                  loading={this.state.waiting}
                >
                  {yesButtonText}
                </Button>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

ImportCSV.propTypes = {
  handleSubmit: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ImportCSV;
